import * as React from 'react';
import translate from '../../locale/translate';

import { IInputChangeEventHandler, IReportSettings } from '../../interfaces';
import { CustomerSelect, RangeDatePicker } from './';

import Customer from '../../store/models/Customer';

interface IProps {
    className?: string,
    settings: IReportSettings,
    customers: Customer[],
    onChange: IInputChangeEventHandler,
}

export default class ReportSettingsForm extends React.Component<IProps, {}> {
    static propTypes = {
        className: React.PropTypes.string,
        settings: React.PropTypes.object.isRequired,
        customers: React.PropTypes.array.isRequired,
        onChange: React.PropTypes.func.isRequired,
    };

    render() {
        const { onChange, className, customers, settings } = this.props;

        return (
            <form className={className}>
                <div className="form-group m-r-xs" style={{ width: '10.6%' }}>
                    <p className="form-control-static">{translate.gettext("Sample data")}</p>
                </div>
                <div className="form-group m-r-xs">
                    <CustomerSelect handleChange={onChange} customers={customers} customerId={this.props.settings.customerId} />
                </div>
                <div className="form-group">
                    <RangeDatePicker handleChange={onChange} start={this.props.settings.startMs} end={this.props.settings.endMs} />
                </div>
            </form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/reportSettings/Form.tsx